import { html } from "lit";
import { getDummyText, renderStandardPictureElement } from "../../../../utils";

const contentTeaserData = {
    title: "TRUMPF Lorem ipsum dolor sit amet",
    body: getDummyText(260),
    ctaText: "mehr erfahren",
    ctaLinkUrl: "#",
    imageDimensions: [825, 390],
    customImage: null,
};

const renderClassicTeaserImage = () => {
    return html`
        ${renderStandardPictureElement({
            width: 825,
            height: 390,
        })}
    `;
};

export const ContentTeaserTemplate = (args) => {
    const teaserData = { ...contentTeaserData, ...args };
    return html`
        <div
            class="ux-iws-teaser-content${args.segmentation === "1-2"
                ? "--segmentation-1-2"
                : ""} ${args.row ? "ux-iws-teaser-content--early-row" : ""}"
        >
            <div class="ux-iws-teaser-content__image-wrapper">
                ${!teaserData.customImage
                    ? html`${renderClassicTeaserImage()}`
                    : html`<img src=${teaserData.customImage} alt="" />`}
            </div>
            <div class="ux-iws-teaser-content__content">
                <h2
                    class="headline-medium ${args.segmentation === "1-2"
                        ? "ux-u-margin-top-0"
                        : "ux-u-margin-top-25"}
                        ${args.row
                        ? "ux-u-margin-m-top-0"
                        : "ux-u-margin-xl-top-0"} ux-u-margin-bottom-15"
                >
                    ${teaserData.title}
                </h2>
                <p class="ux-text-normal ux-u-margin-bottom-30">
                    ${teaserData.body}
                </p>
                <a class="ux-button ux-u-top-30" href="${teaserData.ctaLinkUrl}"
                    >${teaserData.ctaText}</a
                >
            </div>
        </div>
    `;
};
